export default __webpack_public_path__ + "static/media/detailed_brochure.579ee77c.png";